// src/components/atomic-crm/companies/GridList.tsx
import { useState, useEffect } from "react";
import { RecordContextProvider, useListContext } from "ra-core";

import type { Company } from "../types";
import { CompanyCard } from "./CompanyCard";
import { CompanyRow } from "./CompanyRow";

const times = (nbChildren: number, fn: (key: number) => any) =>
  Array.from({ length: nbChildren }, (_, key) => fn(key));

const LoadingGridList = () => (
  <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
    {times(8, (key) => (
      <div key={key} className="h-[200px] rounded-lg bg-muted animate-pulse" />
    ))}
  </div>
);

const LoadingRowList = () => (
  <div className="w-full flex flex-col divide-y">
    {times(8, (key) => (
      <div key={key} className="flex items-center gap-3 py-3 px-2">
        <div className="h-9 w-9 rounded-full bg-muted shrink-0" />
        <div className="flex-1 space-y-2">
          <div className="h-3 w-1/2 rounded bg-muted" />
          <div className="h-3 w-2/3 rounded bg-muted" />
        </div>
      </div>
    ))}
  </div>
);

const LoadedGridList = () => {
  const { data, error, isPending } = useListContext<Company>();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (isPending || error) return null;
  if (data.length === 0) return <div className="p-2">No companies found</div>;

  if (isMobile) {
    return (
      <div className="w-full flex flex-col divide-y divide-border rounded-lg border bg-card">
        {data.map((record) => (
          <RecordContextProvider key={record.id} value={record}>
            <CompanyRow />
          </RecordContextProvider>
        ))}
      </div>
    );
  }

  return (
    <div className="w-full gap-4 grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))]">
      {data.map((record) => (
        <RecordContextProvider key={record.id} value={record}>
          <CompanyCard />
        </RecordContextProvider>
      ))}
    </div>
  );
};

export const ImageList = () => {
  const { isPending } = useListContext();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return isPending ? (
    isMobile ? (
      <LoadingRowList />
    ) : (
      <LoadingGridList />
    )
  ) : (
    <LoadedGridList />
  );
};
